/**
 * The Lotus Text Boxes admin page's entry: the label the admin page list
 * shows for it, its route, and one sentence on what it is for. The admin
 * routes read its path, and the admin page list (`adminPages.ts`), which the
 * admin menu and the admin home show, reads all three. It sits apart from the
 * page so the page list reads it without importing the page.
 */
export const editorTextBoxFuneralHomeLimitPageEntry = {
  title: 'Lotus Text Boxes',
  path: '/admin/lotus-text-boxes',
  description:
    'Turn the Lotus limit on or off and choose the funeral homes offered Lotus text boxes.',
} as const
